export const LOG_TYPE = {
    "Commentary Logs": 1,
    "Virtual Logs": 2
}